import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {
  BSP,
  DARSHAN,
  FMF_M,
  ILM,
  LBYANTRA,
  SAMYAMA,
  SANNIDHI
} from '../constants/programConstants'
import lodgeImage from '../../static/img/lodge-1.jpg'
import mahimaStayImage from '../../static/img/isha-home.jpg'
import kingSuiteImage from '../../static/img/king-suite.jpg'
import queenSuiteImage from '../../static/img/queen-suite.jpg'
import studioImage from '../../static/img/studio.jpg'
import cabinImage from '../../static/img/cabin.jpg'
import { roomTypes } from '../constants/roomConstants'

const SUPPORT_CONTACT = extConfig.SUPPORT_CONTACT

const SuiteAgeNote = () => (
  <Highlight>
    <strong>Age Requirement:</strong> Minimum age is 14 for Suite
    Accommodations; children are not allowed
  </Highlight>
)

const Highlight = ({ children }) => (
  <span className='orange bold'>{children}</span>
)

export function getRoomImage(type) {
  if (type === roomTypes.lodge) {
    return lodgeImage
  } else if (type === roomTypes.mahimaStay) {
    return mahimaStayImage
  } else if (type === roomTypes.kingSuite) {
    return kingSuiteImage
  } else if (type === roomTypes.queenSuite) {
    return queenSuiteImage
  } else if (type === roomTypes.cabin) {
    return cabinImage
  } else {
    return studioImage
  }
}

class RoomDescription extends Component {
  static PropTypes = {
    type: PropTypes.string.required
  }

  render() {
    const { type, program } = this.props

    const meals = <span>Two meals per day,</span>

    if (type === 'Lodge') {
      return (
        <div>
          <p>
            The Semi-Private rooms have 8 beds in a hall with attached common
            bathrooms. Beds are separated into cozy cubicles with simple
            furnishings. This shared accommodation is ideal for individual
            visitors and a nice opportunity to interact with other travelers and
            volunteers staying at the yoga center.
          </p>
          <p>There are separate lodge buildings for men and women.</p>
          <ul>
            {program === ILM && (
              <li>
                <strong>Program accommodation fee:</strong> $110 (2 nights)
              </li>
            )}
            <li>
              {program === ILM ? (
                <Highlight>
                  <strong>Age Requirement:</strong> Minimum Age is 15
                </Highlight>
              ) : (
                <Highlight>
                  <strong>Age Requirement:</strong> Minimum Age is 7 (must be
                  accompanied by an adult)
                </Highlight>
              )}
            </li>
            <li>
              <strong>Maximum Persons per Room:</strong> 1
            </li>
            {program !== ILM && (
              <li>
                <strong>Rate per Night:</strong> $55
              </li>
            )}
            <li>
              <strong>Included:</strong> {meals} Linens, Towel
            </li>
            {program !== ILM && (
              <li>
                <strong>Note:</strong> All children staying in the lodges need
                to stay in their respective gender lodge.
              </li>
            )}
          </ul>
        </div>
      )
    } else if (type === 'Studio') {
      return (
        <div>
          <p>
            These spacious private accommodations have different room options
            based on on the size of your party. They include an attached
            bathroom and king or queen bed. Many of these rooms have picturesque
            views of the surrounding forest and campus, and are ideal for
            couples, families, or those who prefer additional privacy.
          </p>
          <ul>
            <li>
              <strong>Age Requirement:</strong> None
            </li>
            <li>
              <strong>Maximum Persons per Room:</strong>{' '}
              {program === ILM
                ? 'Up to 3 Adults'
                : '4 Persons total, up to 3 Adults maximum'}
            </li>
            <li>
              <strong>Rate per Night:</strong>
              <ul>
                <li>$135 for 1 Person</li>
              </ul>
            </li>
            <li>
              <strong>Included in the room:</strong> {meals} Linens, Towels,
              Toiletries, Water Kettle & Tea (studio tap water is drinkable),
              Tables and/or Couches, Fans
            </li>
            <li>
              <strong>Note:</strong> Studio Room levels could range from 1st to
              3rd floors. If you require a ground floor room, please call{' '}
              {SUPPORT_CONTACT} to check availability.
            </li>
            <li>
              Please note that there is some construction going on at this time
              on the campus, so there may be some construction noise at times.
            </li>
          </ul>
        </div>
      )
    } else if (type === 'Queen Suite') {
      return (
        <div>
          <p>
            Deluxe Suites are luxurious private suites perched on a forested
            bluff overlooking the picturesque mountain valley. Tucked away from
            the main campus and surrounded by natural beauty, retreat in the
            quietude of the surrounding forest; relax on the back terrace and
            take-in a breathtaking sunset, or close your eyes and enjoy the cool
            rush of the nearby waterfall.
          </p>
          <ul>
            <li>
              <SuiteAgeNote />
            </li>
            <li>
              <strong>Rate per Night:</strong> $200 for 1 adult
            </li>
            <li>
              <strong>Maximum Persons per Room:</strong> 2
            </li>
            <li>
              <strong>Included in the room:</strong> {meals} Laundry Room,
              Living Room, Dining Room, and Private Terrace Access, Iron with
              Ironing Board
            </li>
            <li>
              <strong>Note:</strong> Some suites are accessible only by stairs.
              Please call the Welcome Center at {SUPPORT_CONTACT} to request a
              ground-level suite if needed.
            </li>
          </ul>
        </div>
      )
    } else if (type === 'King Suite') {
      return (
        <div>
          <p>
            Deluxe Suites are luxurious private suites perched on a forested
            bluff overlooking the picturesque mountain valley. Tucked away and
            surrounded by natural beauty, retreat in the quiet of the
            surrounding forest; relax on the back terrace and take-in a
            breathtaking sunset, or close your eyes and enjoy the cool rush of
            the nearby waterfall. King Suites are our most luxurious and
            spacious accommodations; each room is unique in design with some
            featuring a fireplace and/or a balcony. The King suite is located
            upstairs.
          </p>
          <ul>
            <li>
              <SuiteAgeNote />
            </li>
            <li>
              <strong>Rate per Night:</strong>
              <ul>
                <li>$300 for 1 adult</li>
              </ul>
            </li>
            <li>
              <strong>Maximum Persons per Room:</strong> 4
            </li>
            <li>
              <strong>Included in the room:</strong> {meals} Laundry Room,
              Living Room, Dining Room, and Private Terrace Access, Iron with
              Ironing Board
            </li>
            <li>
              <strong>Note:</strong> Some suites are accessible only by stairs.
              Please call the Welcome Center at {SUPPORT_CONTACT} to request a
              ground-level suite if needed.
            </li>
          </ul>
        </div>
      )
    } else if (type === roomTypes.mahimaStay) {
      return (
        <div>
          {program === BSP && (
            <p>
              <Highlight>
                Please ensure to book with the email address you used for BSP
                registration
              </Highlight>
            </p>
          )}
          {program === FMF_M ? (
            <div>
              <p>
                This is an opportunity for individuals to sleep in the powerful
                energies of Mahima, a consecrated meditation hall. (Limited
                Spots available). At 39,000 square feet, Mahima is the largest
                meditation hall in the Western Hemisphere. It has ample space
                for everyone to sleep with sufficient distance, and is well
                ventilated during both summer and winter months.
              </p>
              <p>
                This includes shared luggage areas and bathroom facilities. All
                bedding will be provided (mattress, pillow, pillow case,
                linens), but please bring your own blanket if possible or if
                traveling by car. Some blankets will be available for borrowing
                if needed. The space is frequently sanitized and all the
                recommended precautionary measures will need to be followed
                during your stay in the hall.
              </p>
            </div>
          ) : program === ILM ? (
            <div>
              <p>
                <strong>Please note:</strong> Mahima stay will only be available
                from 7pm on Monday the 27th.
              </p>
              <p>
                This is an opportunity for individuals to sleep in the powerful
                energies of Mahima, a consecrated meditation hall. (Limited
                Spots available).
              </p>
              <p>
                This option includes shared luggage areas and bathroom
                facilities. All bedding will be provided (mattress, pillow,
                pillow case, linens), but please bring your own blanket The
                space is frequently sanitized and all the recommended
                precautionary measures will need to be followed during your stay
                in the hall.
              </p>
            </div>
          ) : program === SAMYAMA ? (
            <p>
              All Participants will be sleeping in their respective program
              halls and will use a separate space which has common bathrooms and
              luggage spots to keep luggage. Volunteers will be sleeping in
              shared accommodations.
            </p>
          ) : (
            <p>
              All participants will be sleeping in the consecrated hall, Mahima,
              and will book a separate space which has a common bathroom and
              "luggage spots" to keep luggage.
            </p>
          )}

          {(program === BSP ||
            program === SANNIDHI ||
            program === LBYANTRA ||
            program === DARSHAN) && (
            <ul>
              <li>
                <strong>Rate per Night:</strong> $55
              </li>
            </ul>
          )}

          {program === ILM && (
            <li>
              <strong>Program accommodation fee:</strong> $110 (2 nights)
            </li>
          )}

          {program === SANNIDHI && (
            <div>
              <p>
                <Highlight>
                  If you have children under 7 please book off-campus
                  accommodations
                </Highlight>
              </p>

              <p>
                <Highlight>
                  Children are not permitted to attend the yantra ceremony and
                  must be accompanied by an adult at all times.
                </Highlight>
              </p>

              <p>
                <Highlight>
                  Overnight accommodation is available only for October 29th.
                  Check out time is 11am.
                </Highlight>
              </p>
            </div>
          )}
          {program === LBYANTRA && (
            <p>
              <Highlight>
                If you have children under 7 please book off-campus
                accommodations
              </Highlight>
            </p>
          )}
        </div>
      )
    } else if (type === roomTypes.cabin) {
      return (
        <div>
          <p>
            These single private accommodations offer a panoramic view of the
            mountain valley. Cabin rooms have an attached bathroom and twin bed.
          </p>
          <ul>
            <li>
              <strong>Age Requirement:</strong> 18 and above
            </li>
            <li>
              <strong>Maximum Persons per Room:</strong> 1 person
            </li>
            <li>
              <strong>Rate per Night:</strong> $135
            </li>
            <li>
              <strong>Included in the room:</strong> Two meals per day, Linens,
              Towels
            </li>
          </ul>
          <p>
            Note: Due to uneven terrain by the cabins, if you have limited
            accessibility please call (931) 668-1900 to speak with a volunteer
            to guide you further
          </p>
        </div>
      )
    } else {
      return <div />
    }
  }
}

export default RoomDescription



// WEBPACK FOOTER //
// ./src/components/roomDescription.js